import { MessageSchema } from ".";

export default {
    action: {
        add: "Añadir",
        create: "Crear",
        validate: "Validar",
        createNew: "Crear nuevo",
        update: "Modificar",
        delete: "Eliminar",
        confirm: "Confirmar",
        cancel: "Cancelar",
        close: "Cerrar",
        save: "Guardar",
        clear: "Borrar",
        send: "Enviar",
        search: "Buscar",
        print: "Imprimir",
        import: "Importar",
        synchronize: "Sincronizar",
        share: "Compartir",
        duplicate: "Duplicar",
        renew: "Renovar",
        ok: "Ok",
        retry: "Reintentar",
        REDIRECT_CALENDAR: "Crear y agendar cita",
        REDIRECT_FOLDER: "Crear y acceder al expediente",
        correct: 'Corregir'
    },
    common: {
        info: "Info",
        title: "Título",
        file: "Archivo",
        url: "Url",
        default: "Predeterminado",
        selection: "Selección",
        appointment: {
            status: {
                title: "Estado",
                WAITING_ROOM: "Sala de espera",
                SCHEDULED: "Programada",
                HONOURED: "Cumplida",
                NOT_HONOURED: "No cumplida",
                TO_VALIDATE: "Por validar",
                CANCELLED: "Cancelad"
            },
            patientWarningMsg: 'No se ha podido recuperar el paciente, pero aún así puede modificar esta cita.'
        },
        me: "Yo",
        yes: "Sí",
        no: "No",
        loading: "Cargando ...",
        date: "Fecha",
        from: "Del",
        until: "Al",
        amount: "Monto",
        status: {
            'active': "Activo",
            'unactive': "Desactivado"
        },
        pageable: {
            showing: "Mostrando {first} a {last} de {total}"
        },
        frequency: {
            EVERY_WEEK: "Cada semana",
            EVERY_TWO_WEEKS: "Cada 2 semanas",
            EVERY_THREE_WEEKS: "Cada 3 semanas"
        },
        honorifics: {
            NONE: "",
            MALE: "Sr.",
            FEMALE: "Sra.",
            NON_BINARY: ""
        },
        gender: {
            MALE: "Hombre",
            FEMALE: "Mujer",
            NONE: "No definido",
            NON_BINARY: "Otro"
        },
        patient: 'Paciente',
        patients: 'Pacientes',
        healthPro: 'Profesional de salud',
        healthPros: 'Profesionales de salud',
        user: 'Usuario',
        users: 'Usuarios',
        personRole: {
            HEALTHPRO: "Médico",
            HEALTHPROASSISTANT: "Asistente",
            HEALTHPROSTUDENT: "Estudiante de medicina"
        },
        toast: {
            error: "Ha ocurrido un error",
            warning: "Acción inválida",
            success: {
                add: "Creación exitosa",
                update: "Actualización exitosa",
                delete: "Eliminación exitosa",
                cancel: "Cancelación exitosa",
                deactivate: "Desactivación exitosa",
            }
        },
        patientStatus: {
            WAITING: "Próxima",
            LEAVE: "Finalizada",
            OUT: "Paciente salió"
        },
        newInput: "Añadir: {inputValue}",
        version: "v{version}",
        calendar: {
            future: "Futuro",
            now: "Actual",
            months: "1 mes | {count} meses",
            weeks: "1 semana | {count} semanas",
            days: "1 día | {count} días"
        },
        contactForm: {
            title: {
                phone: "Teléfono",
                email: "Correo electrónico",
                address: "Domicilio"
            },
            label: {
                phone: {
                    actionDefault: "A utilizar por defecto",
                    isDefault: "Se utiliza por defecto"
                },
                address: {
                    actionDefault: "A utilizar por defecto",
                    isDefault: "Se utiliza por defecto"
                },
                email: {
                    actionDefault: "A utilizar por defecto",
                    isDefault: "Se utiliza por defecto"
                } 
            }
        }
    },
    error: {
        DEFAULT: "Ha ocurrido un error",
        EXPRESSION_SAVE_FAILED: "Signo no guardado",
        REQUIRED: "Dato obligatorio",
        REDIRECT: "La redirección no es posible",
        ACTION_FORBIDDEN: "Acción no autorizada",
        APPOINTMENT_TYPE_NOT_FOUND: "Tipo de cita desconocido",
        APPOINTMENT_TYPE_FORBIDDEN_EDIT: "Modificación de tipo de cita no autorizada",
        INSTITUTE_WITH_ROLE_NOT_FOUND: "Instituto desconocido",
        USER_FORBIDDEN: "No tiene permisos para realizar esta acción",
        USER_WITHOUT_AVAILABLE_MODULE: "No tiene acceso a los módulos de la aplicación. Por favor contacte a un administrador.",
        INSTITUTE_ADDRESS_NOT_FOUND: "No hay dirección para este instituto",
        INSTITUTE_ADDRESS_FORBIDDEN_EDIT: "La modificación de esta dirección está prohibida",
        INSTITUTE_ROOM_NOT_FOUND: "Sala de espera desconocida",
        INSTITUTE_ROOM_FORBIDDEN_EDIT: "Modificación de sala de espera no autorizada",
        PERSON_ADDRESS_NOT_FOUND: "Dirección desconocida",
        PERSON_ELEMENT_NOT_ASSOCIATED: "El elemento no está asociado a la persona",
        PERSON_EMAIL_NOT_FOUND: "Dirección de correo electrónico desconocida",
        PERSON_PHONE_NOT_FOUND: "Número de teléfono desconocido",
        PERSON_WITH_ROLE_NOT_FOUND: "Persona desconocida",
        USER_AUTHENTICATED_FAILED: "Error de autenticación",
        SETTINGS_WEEK_MODEL_NOT_FOUND: "Semana estándar desconocida",
        SETTINGS_WEEK_MODEL_NAME_EXIST: "Ya existe una semana estándar con este nombre",
        SETTINGS_DAY_MODEL_NOT_FOUND: "Día estándar desconocido",
        SETTINGS_DAY_MODEL_NAME_EXIST: "Ya existe un día estándar con este nombre",
        APPOINTMENT_NOT_FOUND: "Cita desconocida",
        TIMESLOT_UNAVAILABLE: "Médico no disponible en esta fecha",
        EMPTY_LOCATION: "La sala de espera es obligatoria",
        HEALTH_GROUP_MEMBER_NOT_FOUND: "Instituto desconocido",
        SPECIAL_DAY_PERIOD_ALREADY_EXIST: "Ya existe un día especial para esta fecha",
        SPECIAL_DAY_NOT_FOUND: "Día especial desconocido",
        SPECIAL_DAY_PERIOD_BEFORE_ERROR: "La fecha de fin no puede ser anterior a la fecha de inicio",
        APPOINTMENT_DATE_IN_PAST: "No puedes modificar una cita que ya haya tenido lugar.",
        APPOINTMENT_ALREADY_FINISH: "La cita ya ha sido declarada como terminada",
        APPOINTMENT_CANCELED: "La cita se ha cancelado, no puedes cambiarla de fecha",
        APPOINTMENT_MOVE_DOCTOR_FORBIDDEN: "No puedes cambiar esta cita a otro médico",
        APPOINTMENT_MOVE_TYPE_FORBIDDEN: "No puedes cambiar esta cita por otro tipo de cita",
        APPOINTMENT_MOVE_PATIENT_FORBIDDEN: "No puedes transferir esta cita a otro paciente",
        MOVE_APPOINTMENT_IN_PROGRESS: "Se está cambiando la fecha de una cita",
        APPOINTMENT_DURATION_TOO_LONG: "La duración de una cita no puede abarcar varios días",
        DELETE_FORBIDDEN_NOT_CURRENT_ENTRY: "Eliminación imposible (Esta entrada no está en una consulta actual)",
        DELETE_FORBIDDEN_LAST_ITEM: "Eliminación imposible (Solo hay una entrada en la consulta)",
        DELETE_FORBIDDEN_NOT_SAP_CURRENT_ENTRY: "Eliminación imposible (Esta entrada no está en una consulta actual)",
        DELETE_FORBIDDEN_NOT_EMPTY_CONCLUSION: "La consulta no está vacía",
        DELETE_FORBIDDEN_CONCLUSION_WITH_ORDER_1: "El último grupo de la consulta no puede ser eliminado",
        DELETE_FORBIDDEN_EXPRESSION_TITLE_GROUP: "Eliminación imposible (esta entrada se utiliza en un grupo)",
        VIDEO_NOT_FOUND: "El video solicitado no existe",
        VIDEO_UNVAILABLE: "No hay video disponible",
        DIRECTORY_NOT_FOUND: "El directorio solicitado no existe",
        TASK_BOX_MODULE_NOT_FOUND: "El módulo de tareas no existe",
        APP_USE_NOT_FOUND: "El usuario no existe",
        USER_NOT_IN_INSTITUT: "El usuario no pertenece a un instituto",
        USER_SSN_EXIST: "El identificador LuxTrust ya está asignado",
        DOCTOR_HEALTH_GROUP_MEMBER_NOT_FOUND: "Médico desconocido",
        PERSON_NOT_SPECIFIED: "Persona no especificada",
        INSTITUTE_NOT_SPECIFIED: "Instituto no especificado",
        INSTITUTE_WITHOUT_HEALTH_PRO_GROUP_ROLE: "Instituto sin rol definido",
        CANNOT_DELETE_LAST_INSTITUTE_ADDRESS: "La última dirección de un instituto no puede ser eliminada",
        PERSON_ALREADY_LINKED_WITH_INSTITUTE: "Persona ya vinculada a este instituto",
        CREATE_PERSON_ERROR: "Ha ocurrido un error al crear la persona",
        MANDATORY_DATA_MISSING: "Faltan datos obligatorios",
        PERSON_GENDER_TYPE_ERROR: "Género desconocido",
        PERSON_CNS_NUMBER_ERROR: "Formato de matrícula incorrecto",
        PERSON_CNS_BIRTHDATE_ERROR: "Este número de seguridad social no se corresponde con una fecha de nacimiento válida",
        IS_NOT_A_DOCTOR: "El usuario no es médico",
        HAS_NO_PLANNING: "Sin agenda compartida",
        APPOINTMENT_MANDATORY: "El nombre y la duración son obligatorios",
        APPOINTMENT_TYPE_NAME_EXIST: "Ya existe un tipo de cita con este nombre",
        APPOINTMENT_TYPE_NOTE_LENGTH: "La nota no puede exceder 255 caracteres",
        NO_PATIENT: "El paciente seleccionado no existe",
        FINANCIAL_GROUP_NOT_FOUND: "Grupo financiero desconocido",
        FINANCIAL_CHANNEL_NOT_FOUND: "Canal financiero desconocido",
        FINANCIAL_CHANNEL_AND_GROUP_ERROR: "El canal financiero no pertenece al grupo financiero",
        FINANCIAL_BANK_ACCOUNT_NOT_FOUND: "Datos bancarios desconocidos",
        FINANCIAL_BANK_ACCOUNT_FORBIDDEN_EDIT: "Los datos bancarios no pueden ser modificados",
        SETTINGS_CHANNEL_PERMISSION_NOT_FOUND: "Permiso de canal financiero desconocido",
        CNS_ALREADY_EXIST: "El código CNS ya existe para otra persona",
        RELATION_ID_AND_PATIENT_ID_ARE_NULL: "Paciente desconocido",
        CNS_AFFILIATION_NUMBER_SUFFIX_LENGTH: "El sufijo de matrícula debe tener 5 caracteres",
        CNS_HEALTH_INSURANCE_NOT_FOUND: "Matrícula desconocida",
        GET_PERSON_ERROR: "Error al recuperar la persona",
        UPDATE_PERSON_ERROR: "Error al actualizar los datos de la persona",
        TASKBOX_ALREADY_ASSIGN: "La tarea ya está asignada a 2 personas",
        TASKBOX_RESULT_ALREADY_EXIST: "La tarea 'Resultados' ya existe",
        PATIENT_DOCUMENT_GROUP_NOT_FOUND: "El grupo de documentos no existe",
        PERSON_AND_PATIENT_ALREADY_ASSOCIATED: "La persona ya está asociada al paciente",
        ADD_PERSON_TO_PATIENT_ERROR: "La persona seleccionada no puede ser añadida a este paciente",
        INSTITUTE_PID_ACTIVE_BUT_NOT_HEALTH_GROUP_PRO: "El instituto debe tener el rol Health Pro Group para activar el PID",
        NO_DATA: "El archivo de envío no pudo ser generado",
        HOSPI_DURATION_TOO_LONG: "La duración de la hospitalización excede el límite de {days} días.",
        INVOICE_GENERATE_ERROR: "Ha ocurrido un error al generar la factura de honorarios, por favor intente de nuevo",
        FINANCIAL_GROUP_MISSING_IBAN: "La nota de honorarios no pudo generarse porque falta el IBAN del grupo financiero",
        SETTINGS_DAYS_BY_WEEK_MODEL_NOT_FOUND: "Configuración del día desconocida",
        CNS_AFFILIATION_NUMBER_INVALID: "Matrícula no válida",
        RELATION_ID_IS_NULL: "Ausencia de ID de la relación",
        CNS_NUMBER_IS_EMPTY: "Ausencia de matrícula.",
        INSTITUTE_ID_IS_NULL: "Ausencia de ID del instituto",
        FEE_WRONG_FORMAT: "El monto debe ser un número decimal",
        NO_PDFS_FOUND: "No se encontraron PDFs",
        PDF_LOADING_ERROR: "Error al cargar el PDF",
        TIMESLOT_PERIOD_ALREADY_EXIST: "Ya hay una semana aplicada en este período",
        SETTINGS_WEEK_MODEL_USED: "La semana está siendo utilizada en un período",
        INSTITUTE_EMAIL_IS_USED: "El correo electrónico es utilizado por uno o varios profesionales médicos",
        INSTITUTE_PHONE_IS_USED: "El número de teléfono es utilizado por uno o varios profesionales médicos",
        INSTITUTE_ADDRESS_IS_USED: "La dirección es utilizada por uno o varios profesionales médicos",
        FINANCIAL_GROUP_CODE_TOO_LONG: "El código del grupo financiero debe constar de tres caracteres",
        FINANCIAL_GROUP_MISA_TOO_LONG: "El número Misa del grupo financiero debe tener ocho caracteres",
        FINANCIAL_GROUP_ONLY_ONE_PID: "Este grupo financiero ya tiene un canal PID (solo se permite uno)",
        INSTITUTE_HEADER_NOT_FOUND: "Este encabezado no se encontró",
        INSTITUTE_HEADER_CANNOT_DELETE_LAST: "No se puede eliminar el último encabezado del instituto",
        INSTITUTE_HEADER_IS_USED: "Este encabezado está siendo utilizado por uno o más profesionales médicos",
        PATIENT_DOCUMENT_NOT_CURRENT_ENTRY: "Este documento no pertenece a la consulta actual",
        HEALTH_PRO_HAS_APPOINTMENT: "Se ha programado una cita para este profesional sanitario",
        ENTRY_RELATION_NOT_FOUND: "Entrada desconocida",
        NOT_ENTRY_FOR_THIS_PATIENT: "Esta entrada no está relacionada con el paciente",
        NEW_DOSETIMING: "Se ha definido una nueva posología para un medicamento de esta entrada. Quieres seguir con la eliminación ?",
        ECOSYSTEM_USED_ANOTHER_ENTRY: "Un ecosistema ya se está utilizando en otra consulta. ¿Deseas continuar con la eliminación ?",
        HISTORY_USED_ANOTHER_ENTRY: "Se está utilizando un historial en otra consulta. ¿Quieres seguir con la eliminación ?",
        MONITORING_USED_ANOTHER_ENTRY: "Ya hay un seguimiento en otra consulta. ¿Quieres seguir con la eliminación ?",
        BASIC_USED_ANOTHER_ENTRY: "Un concepto ya se utiliza en otra consulta. ¿Quieres seguir con la eliminación ?"
    },
    warn: {
        APPOINTMENT_EXIST: "Atención, se han programado citas para esta fecha.",
        TOO_LONG: "Atención, la duración de la cita excede el horario disponible",
        NO_TIME_SLOT_FOR_APPT_TYPE_MSG: "Este tipo de cita no está configurado para este horario",
        ONE_DOCTOR_SELECTED: "Debe seleccionar al menos un médico",
        INVALID_DATE_TIME: "Formato de fecha inválido"
    },
    enum: {
        languages: {
            FR: 'Francés',
            EN: 'Inglés',
            DE: 'Alemán',
            ES: 'Español',
            IT: 'Italiano',
            PT: 'Portugués',
            NL: 'Holandés',
            LU: 'Luxemburgués'
        },
        weekday: {
            MONDAY: "Lunes",
            TUESDAY: "Martes",
            WEDNESDAY: "Miércoles",
            THURSDAY: "Jueves",
            FRIDAY: "Viernes",
            SATURDAY: "Sábado",
            SUNDAY: "Domingo"
        }
    },
    menu: {
        settings: 'Configuración',
        admin: 'Admin',
        logout: 'Cerrar sesión',
        help: 'Ayuda',
        tutorial: {
            videoNotDisplay: 'Su navegador no soporta la reproducción de video',
            selectVideo: 'Seleccionar un video'
        },
        idea: 'Buzón de ideas',
        news: 'Novedades eSklepios',
        version: "Versión {version}",
        contactSupport: "Contactar soporte técnico",
        fullscreen: 'Pantalla completa',
        institute: 'Instituto'
    },
    academic: {
        menu: {
            mycme: "my cme",
            cmePulication: "alformec",
            cmeValidation: "acreditación"
        }
    },
    office: {
        menu: {
            incomes: "ingresos",
            expenses: "gastos",
            stock: "inventario",
            orders: "pedidos"
        }
    },
    settings: {
        notification: {
            reminderTitle: "Notificaciones de recordatorio de cita",
            isTodayReminderEnabled: "El mismo día",
            isOneDayBeforeReminderEnabled: "El día anterior",
            isThreeDaysBeforeReminderEnabled: "Tres días antes",
            isOneWeekReminderEnabled: "Una semana antes"
        },
        titleLabels: {
            title1: 'Título 1',
            title2: 'Título 2',
            title3: 'Título 3',
            title4: 'Título 4',
            title5: 'Título 5',
            title6: 'Título 6'
        },
        permissions: {
            institutes: "Institutos"
        },
        menu: {
            duration: "{numberMin} min",
            organization: "Instituto",
            mySettings: "Mis preferencias",
            appointmentTypes: "Tipos de cita",
            waitingRoom: "Salas de espera",
        },
        title: {
            language: "Idioma",
            appointment: "Citas",
            appointmentType: "Lista de tipos de cita"
        },
        tab: {
            main: "General",
            appointmentTye: "Tipos de cita",
            specialDays: "Días especiales",
            planning: "Planificación",
            dayModel: "Días estándar"
        },
        calendar: {
            noHealthPro: "No tiene agenda configurable"
        },
        label: {
            main: {
                subtitle: {
                    calendar: "Configuración de la agenda"
                },
                duration: {
                    label: "Duración de una franja de cita (en min)",
                    success: {
                        update: "Duración de la franja actualizada correctamente"
                    }
                },
                beforeDay: {
                    label: "Número máximo de días de antelación con los que un paciente puede pedir cita",
                    success: {
                        update: "Número de días actualizado correctamente"
                    }
                },
                cancelHour: {
                    label: "Número mínimo de horas antes de la cita en las que un paciente puede cancelarla",
                    success: {
                        update: "Número de horas actualizado correctamente"
                    }
                },
                generalMessage: {
                    label: "Mensaje para los pacientes",
                    success: {
                        update: "Mensaje actualizado correctamente"
                    }
                },
                permissions: {
                    title: "Acceso a mi agenda",
                    loading: "Cargando ...",
                    empty: "Sin permisos definidos",
                    access: "Acceso",
                    admin: "Administración",
                    message: {
                        success: {
                            update: "Permiso actualizado exitosamente"
                        }
                    }
                },
                weekDay: "Días a mostrar en la agenda",
                message: {
                    success: {
                        update: "Días a mostrar actualizados exitosamente"
                    }
                }
            },
            select: {
                institutes: "Instituto",
                healthpros: "Profesional de salud"
            },
            specialDays: {
                modal: {
                    header: "Modificar horarios de un día especial",
                    date: "Fecha",
                    range: "Seleccionar período",
                    dayModel: "Día estándar",
                    period: "Período",
                    add: {
                        title: "Crear día especial",
                    },
                    delete: {
                        title: "Eliminar día especial",
                        message: "Está a punto de eliminar un día especial",
                    }
                },
                toast: {
                    created: "Día especial creado exitosamente",
                    updated: "Día especial actualizado exitosamente",
                    deleted: "Día especial eliminado exitosamente",
                },
                labelQuickParam: "Día especial del {specialDayDate}"
            },
            weekModel: {
                message: {
                    success: {
                        update: "Semana estándar actualizada exitosamente"
                    }
                },
                nameOfNew: "Nueva semana estándar {counter}",
                action: {
                    add: {
                        button: "Añadir un tipo de semana"
                    }
                }
            },
            dayModel: {
                unavailable: "Modelo predeterminado de no disponibilidad. No requiere configuración",
                selectOrCreate: "Seleccionar o crear un día estándar",
                form: {
                    name: "Nombre",
                    timeslot: {
                        start: "Inicio",
                        end: "Fin",
                        delete: "Eliminar"
                    },
                    header: {
                        add: "Añadir día estándar",
                        name: "Modificar nombre del día estándar",
                        timeslot: "Modificar horarios del día estándar",
                        delete: "Eliminar día estándar"
                    },
                    message: {
                        delete: "Está a punto de eliminar un día estándar",
                        success: {
                            add: "Día añadido exitosamente",
                            update: "Día modificado exitosamente",
                            timeslot: "Horarios del día estándar modificados exitosamente",
                            delete: "Día estándar eliminado exitosamente"
                        }
                    }
                }
            },
            planning: {
                action: {
                    openWeekModel: "Gestionar semanas estándar",
                    addTimeslot: "Añadir un período",
                    deleteSelected: "Eliminar períodos seleccionados"
                },
                weekModel: {
                    header: "Gestión de semanas estándar",
                    weekStandard: "Semana estándar"
                },
                noData: "Ningún período configurado",
                column: {
                    slot: "Período",
                    weekModel: "Semana estándar aplicada"
                },
                tooltip: "Al menos un día especial está incluido en este período. Los días especiales reemplazan la configuración de la semana seleccionada.",
                modale: {
                    delete: {
                        header: "Eliminar período",
                        message: "Está a punto de eliminar un período"
                    },
                    deleteSelected: {
                        header: "Eliminar períodos",
                        message: "Está a punto de eliminar varios períodos"
                    },
                    addTimeslot: {
                        header: "Añadir un período",
                        startDate: "Fecha de inicio",
                        endDate: "Fecha de fin",
                        frequency: "Frecuencia",
                        weekModel: "Semana estándar",
                        startDateRequired: "Introduce la fecha de inicio",
                        endDateRequired: "Introduce la fecha de finalización",
                        frequencyRequired: "Introduce la frecuencia",
                        weekModelRequired: "Introduce el modelo de semana",
                        warning: "Si el nuevo período se superpone con un período ya configurado, la configuración existente será reemplazada por la nueva."
                    }
                },
                message: {
                    success: {
                        delete: "Período eliminado exitosamente",
                        update: "Período modificado exitosamente",
                        add: "Período añadido exitosamente"
                    }
                }
            },
            appointmentType: {
                fieldColor: "Color",
                name: "Nombre",
                order: "Orden",
                duration: "Duración",
                note: "Mensaje para pacientes",
                offline: "Reserva de citas en portal",
                action: "Acción",
                online: "Libre",
                patient: "Reservado para pacientes de confianza",
                offlineStatus: "No disponible",
                durationUnit: "{count} min x",
                explanationDuration: "La duración corresponde al producto del valor ingresado durante la creación y la duración predeterminada establecida en la pestaña \"General\".",
                delete: {
                    header: "Eliminar tipo de cita",
                    message: "Está a punto de eliminar un tipo de cita"
                },
                add: {
                    header: "Añadir tipo de cita"
                },
                update: {
                    name: "Modificar nombre del tipo de cita"
                },
                message: {
                    success: {
                        update: "Tipo actualizado exitosamente",
                        add: "Tipo añadido exitosamente",
                        delete: "Tipo eliminado exitosamente"
                    }
                }
            },
            waitingRoom: {
                name: "Nombre",
                nameRequired: "Introduce un nombre",
                maxLivePlaces: 'Capacidad máxima',
                address: "Dirección",
                badge: "Insignia",
                noBadge: "Sin insignia",
                noAddress: "Sin dirección",
                byDefault: "Predeterminada",
                street: "Calle",
                action: "Acción",
                add: {
                    header: "Añadir sala de espera"
                },
                edit: {
                    header: "Modificar sala de espera"
                },
                delete: {
                    header: "Eliminar sala de espera",
                    message: "Está a punto de eliminar una sala de espera"
                },
                message: {
                    success: {
                        update: "Sala de espera actualizada exitosamente",
                        add: "Sala de espera añadida exitosamente",
                        delete: "Sala de espera eliminada exitosamente"
                    }
                }
            },
            instituteInformation: {
                name: "Nombre",
                action: "Acción",
            },
            accounting: {
                financialGroup: {
                    title: "Grupos",
                    unactive: "El grupo financiero está desactivado",
                    optionDisabled: "{name} (desactivado)",
                    table: {
                        code: "Código",
                        title: "Título",
                        active: "Activo",
                        empty: "Sin grupo financiero"
                    },
                    message: {
                        success: {
                            update: "Grupo financiero actualizado exitosamente",
                            add: "Grupo financiero añadido exitosamente"
                        }
                    },
                    form: {
                        header: {
                            add: "Añadir grupo financiero",
                            update: "Modificar grupo financiero"
                        },
                        code: "Código",
                        personalInfo: "Info adicional",
                        title: "Título",
                        iban: "IBAN",
                        bic: "Código BIC"
                    },
                    financialChannel: {
                        empty: "Seleccionar o crear un grupo financiero",
                        add: {
                            action: "Añadir canal",
                            header: "Añadir canal",
                            message: {
                                success: "Canal añadido exitosamente"
                            }
                        },
                        permissions: {
                            title: "Permisos para este grupo",
                            payment: "Pagos",
                            edition: "Edición",
                            creation: "Creación"
                        },
                        type: {
                            None: "Ninguno",
                            BankAccount: "Cuenta bancaria",
                            BankCard: "Tarjeta bancaria",
                            Cash: "Efectivo",
                            LuPid: "Pid",
                            DigitalPayment: "Pago digital",
                            LuTp: "Tp",
                            LuTpSocial: "Tp social",
                            Cancelled: "Cancelado"
                        },
                        data: {
                            title: "Título",
                            type: "Tipo",
                            active: "Activo",
                            bank: {
                                fullName: "Nombre",
                                shortName: "Nombre corto",
                                bic: "Código BIC",
                                iban: "IBAN"
                            }
                        },
                        update: {
                            title: "Modificar título del canal",
                            message: {
                                success: "Canal modificado exitosamente"
                            }
                        },
                        error: {
                            missingIban: "Una cuenta bancaria no puede estar activa y no tener un IBAN"
                        }
                    }
                }
            },
            patient: {
                managementDelegate: {
                    title: "Crear entrada de paciente en mi nombre",
                    loading: "Cargando ...",
                    empty: "Sin delegación definida",
                    update: {
                        message: {
                            success: "Delegación modificada exitosamente"
                        }
                    }
                }
            },
            account: {
                institute: {
                    preference: {
                        header: "Preferencia de contacto para {instituteName}",
                        headerLines: "Encabezado",
                        address: "Dirección",
                        phone: "Teléfono",
                        email: "Email",
                        warning: "Estos datos serán visibles en los documentos generados por la aplicación (recetas, notas de honorarios) y el portal de citas.",
                        message: {
                            success: "Preferencias actualizadas con éxito"
                        }
                    }
                }
            },
            task: {
                taskbox: {
                    title: "Tareas",
                    add: {
                        header: "Añadir tarea",
                        message: {
                            success: "Tarea añadida exitosamente"
                        }
                    },
                    update: {
                        header: "Modificar tarea",
                        message: {
                            success: "Tarea modificada exitosamente"
                        }
                    },
                    data: {
                        title: "Título",
                        module: "Tipo de módulo"
                    },
                    moduleType: {
                        NONE: "Ninguno",
                        PATIENT: "Paciente",
                        ACCOUNTING: "Contabilidad",
                        STOCK: "Inventario",
                        STAFF: "Personal",
                        LEARNING: "Formación",
                        TEACHING: "Enseñanza",
                        RESEARCH: "Investigación"
                    },
                    channelType: {
                        NONE: "Ninguno",
                        RESULTS: "Resultado",
                        TWOPERSON: "Dos personas",
                    }
                }
            }
        },
        error: {
            numberMaxChar: "El campo debe tener menos de 255 caracteres",
        },
        params: {
            title: "Configuración",
            tabs: {
                billing: "Facturación"
            },
            preferences: {
                title: "Preferencias",
                subTitle: "Preferencias",
                language: {
                    title: "Idioma",
                    menus: "Menús",
                    snomedct: "Reconocimiento de texto",
                },
                suggestions: {
                    title: "Sugerencias",
                    humanBody: "Esquema corporal",
                    neuro: "Neuro",
                    ent: "ORL",
                    thorax: "Tórax",
                    abdomen: "Abdomen",
                    lymph: "Lymph",
                },
                clinical: {
                    title: "Clínico",
                    reducedByDefault: "Consultas reducidas por defecto",
                    dashboardOphtalmo: "Panel de oftalmología",
                },
            },
            account: {
                details: {
                    title: 'Título',
                    address: "Direcciones",
                    contact: "Contactos",
                    email: "Dirección",
                    mobile: "Móvil",
                    phone: 'Número',
                    note: "Nota"
                },
                prescription: {
                    header: "Encabezado",
                    labelTitleLine1: "Línea de encabezado 1 en receta",
                    labelTitleLine2: "Línea de encabezado 2 en receta",
                    labelCustomLine1: "Línea de encabezado 1",
                    labelCustomLine2: "Línea de encabezado 2",
                    instituteName: "Instituto",
                    instituteFullName: "Nombre completo",
                    instituteShortName: "Nombre abreviado",
                    title: "Encabezados de recetas"
                },
                institutes: {
                    roles: {
                        admin: "Administrador",
                        customLearningSpeaker: "Creador de formación médica continua",
                        customPatient: "Paciente",
                        healthPro: "Médico",
                        healthProAssistant: "Secretario"
                    },
                    title: "Institutos",
                    portailPatient: {
                        title: "Información del portal de pacientes",
                        parking: {
                            title: "Estacionamientos",
                            nameRequired: "Introduce un nombre",
                            add: "Añadir estacionamiento",
                            update: "Modificar estacionamiento",
                            delete: "Eliminar estacionamiento",
                            message: "Está a punto de eliminar un estacionamiento",
                        },
                        transportStop: {
                            title: "Transporte público",
                            nameRequired: "Introduce un nombre",
                            add: "Añadir parada",
                            update: "Modificar parada",
                            delete: "Eliminar parada",
                            message: "Está a punto de eliminar una parada",
                        },
                        slug: {
                            title: "URL del instituto",
                            format: 'Letras sin acentos ni números, separadas por guiones',
                            formatError: "La URL no cumple con el formato permitido",
                            mandatory: "La URL es obligatoria",
                            alreadyUsed: "Esta URL ya existe, elige otra",
                            success: "Se ha modificado correctamente la URL",
                            error: "Error al actualizar la URL"
                        },
                        generalMessage: {
                            title: "Mensaje informativo",
                        },
                    }
                },
                title: "Cuenta",
                toast: {
                    add: {
                        address: "Dirección añadida exitosamente",
                        email: "Correo electrónico añadido exitosamente",
                        phone: "Número de teléfono añadido exitosamente",
                        header: "Encabezado añadido con éxito",
                    },
                    delete: {
                        address: "Dirección eliminada exitosamente",
                        email: "Correo electrónico eliminado exitosamente",
                        phone: "Número de teléfono eliminado exitosamente",
                        parking: "Estacionamiento eliminado exitosamente",
                        stop: "Parada eliminada exitosamente",
                        header: "Encabezado eliminado con éxito",
                    },
                    update: {
                        address: "Dirección modificada exitosamente",
                        email: "Correo electrónico modificado exitosamente",
                        phone: "Número de teléfono modificado exitosamente",
                        information: "Información modificada exitosamente",
                        header: "Encabezado actualizado con éxito",
                    }
                },
                subTitle: "Datos personales",
                portailPatient: {
                    title: "Información del portal de pacientes",
                    fees: "Tarifas",
                    meanOfPayement: "Medios de pago",
                    presentation: "Presentación",
                    diploma: "Diplomas",
                    teleconsultation: "Teleconsulta disponible",
                    openToNewPatient: "Abierto a nuevos pacientes",
                    showAgenda: "Mostrar horarios",
                    showContact: "Mostrar en el portal",
                    schedule: "Horarios",
                    complementaryInformation: "Información complementaria",
                    generalMessage: "Mensaje informativo",
                    slug: {
                        title: "URL del portal",
                        format: 'Letras sin acentos ni números, separadas por guiones',
                        formatError: "La URL no cumple con el formato permitido",
                        mandatory: "La URL es obligatoria",
                        alreadyUsed: "Esta URL ya existe, elige otra",
                        success: "Se ha modificado correctamente la URL",
                        error: "Error al actualizar la URL",
                        noInstituteSlugs: "No hay ningún instituto disponible en el portal"
                    },
                }
            },
            institute: {
                title: "Instituto",
                subTitle: "Datos del instituto"
            },
            patient: {
                title: "Expedientes de pacientes",
                subTitle: "Datos del paciente"
            },
            docPatient: {
                title: "Documentos del paciente",
                subTitle: "Documentos del paciente"
            },
            calendar: {
                title: "Agenda",
                subTitle: "Agenda"
            },
            task: {
                title: "Tareas",
                subTitle: "Tareas"
            },
            waitingRoom: {
                title: "Salas de espera"
            },
            tasks: {
                title: "Tareas",
                subTitle: "Tareas",
                patientnote: "Nota de expediente",
                clinic: "Nota clínica",
                admin: "Nota administrativa"
            },
            billing: {
                title: "Facturación",
                subTitle: "Facturación"
            },
            permission: {
                title: "Permisos",
                subTitle: "Permisos",
                update: "Permiso modificado"
            },
            notification: {
                title: "Notificaciones",
                subTitle: "Notificaciones"
            }
        },
        permission: {
            viewUsers: "Ver usuarios",
            editUsers: "Modificar usuarios",
            writePrescriptions: "Escribir recetas",
            viewAppointments: "Ver citas",
            empty: "Sin permisos",
            roles: {
                admin: {
                    label: "Administración del instituto",
                    ADMIN_INSTITUTE: "Administración del instituto",
                },
                prescription: {
                    label: "Receta",
                    WRITE_PRESCRIPTION: "Crear/modificar receta",
                    READ_PRESCRIPTION: "Leer receta",
                    SIGN_PRESCRIPTION: "Firmar receta"
                },
                task: {
                    label: "Tareas / Misiones",
                    ACCESS_TASK: "Acceso al módulo de tareas"
                },
                patient: {
                    label: "Paciente",
                    ADD_PATIENT_DOCUMENT: "Crear documento administrativo",
                    MODIFY_PATIENT_DATA: "Modificar expediente clínico del paciente",
                    READ_PATIENT_DATA: "Consultar expedientes clínicos de pacientes vinculados al instituto",
                    DELETE_PATIENT_DOCUMENT: "Eliminar documento administrativo",
                    EDIT_PATIENT_ADMIN_DATA: "Modificar datos administrativos del paciente"
                },
                planning: {
                    label: "Agenda",
                    CREATE_PLANNING: "Crear planificación",
                    ACCESS_PLANNING: "Acceso al módulo de agenda",
                    MODIFY_PLANNING: "Editar planificación",
                    OWNER_PLANNING: "Agenda personal"
                },
                accounting: {
                    label: "Gestión contable",
                    ACCESS_ACCOUNTING: "Acceso al módulo de contabilidad"
                }
            },
            datatableTitle: "Lista de profesionales de salud",
            title: "Permisos para {name}"
        }
    },
    layout: {
        agenda: "Agenda",
        task: "Tareas",
        patient: "Paciente",
        waitingroom: "Sala de espera",
        finance: "Contabilidad",
        forum: "Mensajería",
        settings: "Configuración",
        material: "Material",
        fastPatientCreation: 'Nuevo Paciente',
        staff: "Personal"
    },
    admin: {
        subMenu: {
            title: "Administración",
            institute: "Institutos",
            medicalPerson: "Profesionales de salud",
            permissions: "Permisos",
            financialGroups: "Grupos financieros",
            notifications: "Notificaciones"
        },
        financialGroup: {
            datatableTitle: "Lista de grupos financieros comunes",
            search: "Búsqueda",
            table: {
                title: "Nombre",
                code: "Código",
                active: "Activo",
                empty: "Sin grupo financiero",
                misaNumber: "Número Misa",
                personalInfo: "Info adicional",
                medicalPerson: "Profesionales de salud"
            },
            form: {
                add: {
                    header: "Añadir grupo financiero común",
                    message: {
                        success: "Grupo financiero común añadido exitosamente"
                    }
                },
                update: {
                    header: "Modificar grupo financiero común",
                    message: {
                        success: "Grupo financiero común modificado exitosamente"
                    }
                },
                code: "Código",
                title: "Nombre",
                misaNumber: "Número Misa",
                personalInfo: "Info adicional",
                active: "Activo"
            },
            person: {
                title: "Profesionales de salud del grupo {title}",
                search: "Búsqueda",
                table: {
                    empty: "Sin profesional de salud",
                    name: "Nombre completo",
                    role: "Rol",
                    active: "Activo",
                    isOwner: "Administrador del grupo",
                    delete: "Eliminar"
                },
                form: {
                    institute: "Instituto",
                    person: "Profesional de salud",
                    isOwner: "Administrador del grupo",
                    ownerWarning: "Solo un administrador posible. Esta acción eliminará los derechos de administración existentes."
                },
                add: {
                    message: {
                        success: "Profesional de salud añadido exitosamente"
                    }
                },
                update: {
                    header: {
                        confirm: "Modificación del administrador"
                    },
                    message: {
                        success: "Profesional de salud modificado exitosamente"
                    }
                },
                delete: {
                    modale: {
                        header: "Eliminar acceso del profesional de salud",
                        message: "Está a punto de eliminar el acceso al grupo financiero para un profesional de salud",
                        messageOwner: "Está a punto de eliminar el acceso al grupo financiero para el administrador"
                    },
                    message: {
                        success: "Acceso del profesional de salud eliminado exitosamente"
                    }
                }
            }
        },
        institute: {
            search: "Búsqueda",
            table: {
                name: "Nombre",
                instituteRole: "Rol",
                active: "Activo",
                empty: "Sin instituto",
                admin: "Administrador",
                update: "Modificar"
            },
            label: {
                add: {
                    header: "Añadir instituto",
                    message: {
                        success: "Instituto añadido exitosamente"
                    }
                },
                update: {
                    header: "Modificar instituto",
                    message: {
                        success: "Instituto modificado exitosamente"
                    }
                }
            },
            form: {
                data: "Información",
                name: "Nombre",
                shortName: "Nombre abreviado",
                role: "Rol",
                address: "Dirección",
                street: "N° y calle",
                locality: "Ciudad",
                postalCode: "Código postal",
                country: "País",
                userAdmin: "Administrador",
                options: "Opciones",
                pidActivation: "PID",
                fastPatientCreationActive: 'Creación rápida de pacientes',
                ophthalmoDashboard: 'Panel de oftalmología',
                externalId: "ID externo",
            },
            person: {
                title: "Administradores del instituto {name}",
                search: "Búsqueda",
                table: {
                    empty: "Sin administrador",
                    firstname: "Nombre",
                    lastname: "Apellido",
                    role: "Rol"
                },
                add: {
                    message: {
                        success: "Administrador añadido exitosamente"
                    }
                },
                header: {
                    generalInfo: "Información general",
                    options: "Opciones"
                },
                form: {
                    firstname: "Nombre",
                    lastname: "Apellido",
                    gender: "Género",
                    birthdate: "Fecha de nacimiento",
                    title: "Título",
                    role: "Tipo",
                    misaNumber: "Código médico",
                    nlpPref: "Idioma Snomed CT",
                    ssnLt: "Identificador Luxtrust",
                    favoritePhone: "Teléfono",
                    favoriteEmail: "Correo electrónico",
                    favoriteLanguage: "Idiomas hablados",
                    portalPatientModule: "Portal de pacientes",
                    iban: "IBAN",
                    bic: "BIC"
                }
            }
        },
        medicalPerson: {
            table: {
                name: "Profesional",
                active: "Activo",
                institut: "Institutos",
                role: "Rol",
                empty: "Sin profesional",
                update: "Modificar"
            },
            institute: {
                title: "Institutos de {name}",
                search: "Búsqueda",
                table: {
                    empty: "Sin instituto",
                    name: "Nombre del instituto",
                    role: "Rol",
                    active: "Estado",
                    isAdmin: "Administrador",
                    edit: "Modificar",
                    delete: "Eliminar"
                },
                form: {
                    institute: "Instituto",
                    adminPermission: "Administrador"
                },
                add: {
                    message: {
                        success: "Instituto añadido exitosamente"
                    }
                },
                edit: {
                    message: {
                        success: "Instituto modificado exitosamente"
                    }
                },
                delete: {
                    modale: {
                        header: "Eliminar persona",
                        message: "Está a punto de eliminar una persona vinculada al instituto"
                    },
                    message: {
                        success: "Profesional de salud eliminado exitosamente"
                    }
                }
            },
            form: {
                header: {
                    add: "Añadir profesional de salud",
                    update: "Modificar profesional de salud"
                },
                message: {
                    success: {
                        add: "Profesional de salud añadido exitosamente",
                        update: "Profesional de salud modificado exitosamente"
                    }
                }
            }
        },
        notifications: {
            message: {
                success: {
                    add: "Plantilla de notificación añadida exitosamente",
                    update: "Plantilla de notificación modificada exitosamente"
                }
            },
        }
    },
    calendar: {
        header: {
            weekDays: "Del {first} al {last} ",
            todayButton: "Hoy",
            pastButton: "Anterior",
            nextButton: "Siguiente",
            withoutAppointment: "Sin cita",
            tab: {
                day: "Día",
                week: "Semana"
            },
            appointment: "Cita para :",
            moveAppointment: "Cambio de fecha de la cita del {date} de:"
        },
        menu: {
            calendar: "Calendario"
        },
        alt: {
            patient: "Paciente"
        },
        label: {
            notAccess: "No tienes acceso a ningún calendario. Para obtener uno, ponte en contacto con el administrador de tu centro.",
            forbidden: "{name} no tiene acceso al módulo de agenda",
            update: {
                header: "Modificar cita"
            },
            add: {
                patientWithoutAppointmentHeader: "Nuevo paciente sin cita",
                header: "Nueva cita",
                form: {
                    date: "Fecha",
                    time: "Hora",
                    duration: "Duración (en minutos)",
                    appointmentType: "Tipo de cita",
                    patient: "Paciente",
                    portalPatient: "Cita agendada por",
                    healthPro: "Profesionales de salud",
                    comment: "Comentario",
                    departure: "Hora de salida",
                    arrival: "Llegada a sala de espera",
                    created: "Creado el ",
                    createdAt: "{date} um {time}",
                    createdAtBy: "{date} a las {time} por {author}",
                    addPerson: "Nuevo paciente",
                    lastname: "Apellido",
                    firstname: "Nombre",
                    favoritePhone: "Teléfono",
                    mobile: "Móvil",
                    mail: "Correo electrónico",
                    isPatientWithoutAppointment: "Paciente sin cita",
                    portalError: 'Se ha producido un error al cargar los datos del paciente.'
                }
            },
            delete: {
                action: "Cancelar cita"
            },
            move: {
                action: "Cambiar cita",
                disabled: "Ya hay una cita seleccionada para poder cambiarla de fecha"
            },
            message: {
                success: {
                    add: "Cita añadida exitosamente",
                    update: "Cita modificada exitosamente"
                },
                error: {
                    commentLength: "El campo debe tener menos de 256 caracteres"
                }
            },
            settings: {
                header: "Día especial del {date}"
            },
            existAppointment: {
                header: "Ya hay una cita programada",
                message: {
                    create: "Ya se ha programado una cita en este horario. ¿Desea continuar con la creación?",
                    update: "Ya se ha programado una cita en este horario. ¿Desea continuar con la modificación?"
                }
            }
        },
        appointment: {
            action: {
                finish: "Confirmar salida",
                patientStatus: "Consulta",
                start: "Confirmar llegada",
                restart: "Confirmar regreso",
            },
            delete: {
                modale: {
                    header: "Cancelar cita",
                    message: "Está a punto de cancelar una cita"
                },
                message: {
                    success: "Cita cancelada exitosamente"
                }
            }
        },
        waiting: {
            title: "Salas de espera",
            room: {
                default: "Desconocida",
                location: "Sala de espera"
            },
        },
        history: {
            title: "Historial",
        },
        withoutAppointment: {
            title: "Sin cita previa",
        }
    },
    thirdPerson: {
        create: {
            title: {
                private: "Crear tercera persona para {name}",
                pro: "Crear profesional de salud para {name}",
            },
            form: {
                firstname: "Nombre",
                lastname: "Apellido",
                address: "Dirección",
                street: "N° y calle",
                postalCode: "Código postal",
                locality: "Ciudad",
                country: "País",
                favoritePhone: "Teléfono",
                mobile: "Móvil",
            },
            message: {
                success: {
                    add: "Persona añadida exitosamente"
                },
            }
        },
    },
    healthPro: {
        select: "Seleccionar un profesional de salud",
        search: {
            placeholder: "Nombre ...",
            noResult: "Sin resultados",
        },
    },
    patient: {
        common: {
            bio: "Bio",
            biology: "Biología",
            imaging: "Imagenología",
            medication: "Medicamentos",
            report: "Informe",
            reports: "Informes",
            certificate: "Certificado",
            certificates: "Certificados",
        },
        addMedication: {
            placeholder: "Nombre o DCI ...",
            commercialNames: "Nombres comerciales",
            singleSubstances: "Sustancias",
            multipleSubstances: "Sustancias múltiples",
        },
        addMonitored: {
            childFollowUp: "Seguimiento infantil",
            adultFollowUp: "Seguimiento adulto",
            pregnancyFollowUp: "Seguimiento embarazo",
            travelFollowUp: "Seguimiento viaje",
            favorites: "Favoritos",
        },
        addHistory: {
            stroke: "ACV",
            dementia: "Demencia",
            parkinson: "Parkinson",
            epilepsy: "Epilepsia",
            migraine: "Migraña",
            adhd: "TDAH",
            depressiveDisorder: "Trastorno depresivo",
            anxietyDisorder: "Trastorno de ansiedad",
            bipolarDisorder: "Trastorno bipolar",
            addictionTo: "Adicción a",
            anorexia: "Anorexia",
            bulimia: "Bulimia",
            autisticDisorder: "Trastorno autista",
            schizophrenia: "Esquizofrenia",
            refractionDisorders: "Trastornos de refracción",
            refractionDisordersRightEye: "Trastornos de refracción ojo derecho",
            refractionDisordersLeftEye: "Trastornos de refracción ojo izquierdo",
            cataract: "Catarata",
            cataractRightEye: "Catarata ojo derecho",
            cataractLeftEye: "Catarata ojo izquierdo",
            glaucoma: "Glaucoma",
            glaucomaRightEye: "Glaucoma ojo derecho",
            glaucomaLeftEye: "Glaucoma ojo izquierdo",
            hearingLoss: "Hipoacusia",
            hearingLossRightEar: "Hipoacusia oído derecho",
            hearingLossLeftEar: "Hipoacusia oído izquierdo",
            edentulism: "Edentulismo",
            adenoidectomy: "Adenoidectomía",
            tonsillectomy: "Amigdalectomía",
            copd: "EPOC",
            asthma: "Asma",
            congenitalHeartDefect: "Cardiopatía congénita",
            coronaryArteryDisease: "Enfermedad coronaria",
            hypertensiveHeartDisease: "Cardiopatía hipertensiva",
            atrialFibrillation: "Fibrilación auricular",
            valvularHeartDisease: "Valvulopatía cardíaca",
            venousInsufficiency: "Insuficiencia venosa",
            hepaticSteatosis: "Esteatosis hepática",
            cirrhosis: "Cirrosis",
            appendectomy: "Apendicectomía",
            cholecystectomy: "Colecistectomía",
            malformativeUropathy: "Uropatía malformativa",
            malformativeUropathyRight: "Uropatía malformativa derecha",
            malformativeUropathyLeft: "Uropatía malformativa izquierda",
            renalInsufficiency: "Insuficiencia renal",
            renalLithiasis: "Litiasis renal",
            benignProstaticHyperplasia: "HBP",
            pregnancy: "Embarazo",
            menopause: "Menopausia",
            cesareanSection: "Cesárea",
            hysterectomy: "Histerectomía",
            oophorectomy: "Ooforectomía",
            oophorectomyRight: "Ooforectomía derecha",
            oophorectomyLeft: "Ooforectomía izquierda",
            scoliosis: "Escoliosis",
            hipOsteoarthritis: "Coxartrosis",
            hipOsteoarthritisRight: "Coxartrosis derecha",
            hipOsteoarthritisLeft: "Coxartrosis izquierda",
            kneeOsteoarthritis: "Gonartrosis",
            kneeOsteoarthritisRight: "Gonartrosis derecha",
            kneeOsteoarthritisLeft: "Gonartrosis izquierda",
            hipProsthesis: "Prótesis de cadera",
            hipProsthesisRight: "Prótesis de cadera derecha",
            hipProsthesisLeft: "Prótesis de cadera izquierda",
            kneeProsthesis: "Prótesis de rodilla",
            kneeProsthesisRight: "Prótesis de rodilla derecha",
            kneeProsthesisLeft: "Prótesis de rodilla izquierda",
            atopicDermatitis: "Dermatitis atópica",
            acne: "Acné",
            psoriasis: "Psoriasis",
            hypothyroidism: "Hipotiroidismo",
            hyperparathyroidism: "Hiperparatiroidismo",
            hypertension: "HTA",
            diabetes: "Diabetes",
            dyslipidemia: "Dislipidemia",
            hyperuricemia: "Hiperuricemia",
            bacterialPneumonia: "Neumonía bacteriana",
            toxoplasmosis: "Toxoplasmosis",
            allergy: "Alergia",
            brainCancer: "Cáncer cerebral",
            lungCancer: "Cáncer pulmonar",
            colonCancer: "Cáncer de colon",
            pancreaticCancer: "Cáncer de páncreas",
            prostateCancer: "Cáncer de próstata",
            breastCancer: "Cáncer de mama",
            breastCancerRight: "Cáncer de mama derecho",
            breastCancerLeft: "Cáncer de mama izquierdo",
            leukemia: "Leucemia",
            favorites: "Favoritos",
            left: "izquierdo",
            right: "derecho",
            in: "en",
            yearsAgo: "hace",
            years: "años",
            atAge: "a la edad de",
            inChildhood: "en la infancia",
            since: "desde",
            sinceAge: "desde la edad de",
            sinceChildhood: "desde la infancia",
            fatherSide: "por parte del padre",
            motherSide: "por parte de la madre",
            rightAbbr: "D",
            leftAbbr: "I",
        },
        addEcosystem: {
            job: "Profesión:",
            workTime: "Tiempo de trabajo:",
            hoursPerWeek: "horas por semana",
            workTimeLabel: "Tiempo de trabajo: h/sem",
            noPartner: "Sin pareja",
            inCouple: "En pareja",
            parents: "Padres:",
            children: "Hijos:",
            pets: "Mascotas:",
            petsValue: "Animales:",
            violence: "Violencia:",
            autonomousAtHome: "Autónomo en casa",
            livesOnFloor: "Vive en el",
            floor: "piso",
            livesOnFloorLabel: "Vive en el ... piso",
            nursingHome: "En residencia de ancianos",
            walkingAid: "Ayuda para caminar:",
            homeHelp: "Ayuda domiciliaria:",
            sleepLatency: "Tiempo para dormirse:",
            nightWakings: "Despertares nocturnos:",
            averageSleepDuration: "Duración promedio del sueño:",
            physicalActivity: "Actividad física:",
            drinks: "Bebidas:",
            diet: "Dieta:",
            noSmoking: "No fumador",
            smoking: "Tabaquismo:",
            cigarettesPerDay: "cigarrillos por día",
            smokingLabel: "Tabaquismo: ... cig./día",
            noAlcohol: "Sin alcohol",
            alcohol: "Alcohol:",
            glassesPerWeek: "vasos estándar por semana",
            alcoholLabel: "Alcohol: ... vasos/sem",
            noDrugs: "Sin drogas",
            cannabis: "Cannabis:",
            cocaine: "Cocaína:",
            opioids: "Opioides:",
            favorites: "Favoritos",
            left: "izquierdo",
            right: "derecho",
            in: "en",
            yearsAgo: "hace",
            years: "años",
            atAge: "a la edad de",
            since: "desde",
            sinceAge: "desde la edad de",
        },
        no_entry: "Sin entrada",
        header: {
            report: "Informe",
            reportWithHistory: "Informe con antecedentes",
            reportWithHistoryShort: "Informe completo",
            operativeReport: "Informe operatorio",
            lab: "Laboratorio",
            pharma: "Farmacia",
            billing: "Factura"
        },
        expression: {
            addSigns: "Agregar signos ...",
            isCorrected: "editado",
            history: "Historial",
            doctor: {
                importedFor: "Importado para:",
                by: "por: {secondaryHealthPro}",
                for: "para:",
            }
        },
        expressionMoreMenu: {
            createGroup: "Crear grupo",
            rename: "Renombrar",
            correct: "Corregir",
            moveToMonitored: "Mover a Seguimientos",
            moveToHistory: "Mover a Antecedentes",
            moveToEcosystem: "Mover a Ecosistema",
            removeFromBar: "Quitar de la barra",
            nlp: "NLP",
        },
        conclusionGroup: {
            numberedTitle: "Grupo {number}",
            placeholder: "Plan, recetas ...",
        },
        suggestion: {
            sign: {
                Groups: "Grupos",
                Measures: "General",
                CranialNerves1: "Pares craneales",
                NeuroPeriph: "Neuro periférico",
                MotorCoordination: "Equilibrio, coordinación",
                Head: "Cabeza",
                Ent: "ORL",
                Thorax: "Tórax",
                Abdomen: "Abdomen",
                ShoulderL: "Hombro I",
                ShoulderR: "Hombro D",
                EllbowL: "Codo I",
                EllbowR: "Codo D",
                UpperArmL: "Brazo I",
                UpperArmR: "Brazo D",
                ForeArmL: "Antebrazo I",
                ForeArmR: "Antebrazo D",
                WristL: "Muñeca I",
                WristR: "Muñeca D",
                HandL: "Mano I",
                HandR: "Mano D",
                HipL: "Cadera I",
                HipR: "Cadera D",
                ThighL: "Muslo I",
                ThighR: "Muslo D",
                KneeL: "Rodilla I",
                KneeR: "Rodilla D",
                LowerLegL: "Pierna I",
                LowerLegR: "Pierna D",
                AnkleL: "Tobillo I",
                AnkleR: "Tobillo D",
                FootL: "Pie I",
                FootR: "Pie D",
                Lymph: "Linfático",
            },
            conclusion: {
                adminPerso: "Administrativo / Personal",
            },
        },
        delegate: {
            title: 'Crear una entrada',
            label: 'En nombre de:',
            me: ' (yo) '
        },
        search: {
            placeholder: "Nombre o matrícula ...",
            noResult: "Sin resultados",
            new: "Crear nuevo paciente", 
            invalidDate: "fecha no válida",
            tooLong: "matrícula demasiado larga",
            invalidChecksum: "sufijo no válido",
            newPatient: "nuevo paciente",
        },
        create: {
            title: "Crear paciente para {name}",
            form: {
                cns: "Matrícula",
                firstname: "Nombre",
                lastname: "Apellido",
                mail: "Correo electrónico",
                birthdate: "Fecha de nacimiento",
                gender: "Género",
                address: "Dirección",
                street: "N° y calle",
                postalCode: "Código postal",
                locality: "Ciudad",
                country: "País",
                favoritePhone: "Teléfono",
                mobile: "Móvil",
                import: "Pegar desde el portapapeles",
                importCreate: "Crear paciente desde el portapapeles",
            },
            toast: {
                success: "La información fue recuperada automáticamente.",
                error: "Error al leer el portapapeles.",
                missingBirthdate: "Fecha de nacimiento faltante",
                emptyClipboard: "Portapapeles vacío",
                emptyClipboardDetail: "No hay texto válido para pegar."
            },
            message: {
                success: {
                    add: "Paciente añadido exitosamente"
                },
                mandatory: "Ingresar matrícula o fecha de nacimiento"
            }
        },
        rightBar: {
            subtitle: {
                monitoring: "Seguimientos",
                treatment: "Tratamiento",
                history: "Antecedentes",
                ecosystem: "Ecosistema"
            },
            vaccine: "Vacunas",
        },
        imageViewer: {
            syncZoom: "Sincr. zoom",
            syncPan: "Sincr. desplazamiento",
            close: "Cerrar (Esc)",
            zoomIn: "Acercar (+)",
            zoomOut: "Alejar (-)",
            resetView: "Restablecer (0)",
            scroll: "Desplazar",
            zoom: "Zoom",
            zoomInOut: "Acercar/Alejar",
            reset: "Restablecer",
            pan: "Desplazar",
            closeShort: "Cerrar"
        },
        ophtalmo: {
            title: "Oftalmología",
            correctiveLenses: "Lentes correctivos",
            eyeGlasses: "Anteojos",
            contactLenses: "Lentes de contacto",
            near: "Cerca",
            distant: "Lejos",
            intermediate: "Intermedio",
            bifocal: "Bifocal",
            progressive: "Progresivo",
            highAmetropy: "Ametropía > 6D",
            rigid: "LRPG",
            rigidKeratoconus: "LRPG - Queratocono",
            rigidHighAmetropy: "LRPG - Ametropía > 6D",
            leftEye: "Ojo Izquierdo",
            rightEye: "Ojo Derecho",
            os: "OI",
            od: "OD",
            ou: "AO",
            current: "Actual",
            previous: "Anterior",
            tonometer: "Tonómetro",
            iop: "PIO",
            slitLamp: "Lámpara de hendidura",
            pachymetry: "Paquimetría",
            topography: "Topografía",
            ultrasound: "Ecografía",
            biometrics: "Biometría",
            slitLampFindings: "Hallazgos",
            refraction: "Refracción",
            objective: "Objetivo",
            subjective: "Subjetivo",
            final: "Final",
            sph: "ESF",
            cyl: "CIL",
            axs: "EJE",
            va: "AV",
            add: "ADD",
            nva: "AVC",
            fundus: "Fondo de ojo",
            visualField: "Campo visual",
            oct: "OCT",
            keratometry: "Queratometría",
            k1: "K1",
            k2: "K2",
            diopter: "D",
            noHistory: "Sin antecedentes",
            export: {
                success: "Datos enviados al refractómetro"
            }
        },
        resultDocument: {
            createStructuredData: "Crear datos estructurados",
            notInterpretable: "El grupo ya contiene datos. Creación de datos estructurados desactivada.",
            file: "Archivo {mime}",
            cannotDisplay: "No se puede mostrar. Descarga disponible.",
        },
        document: {
            pid: "PID",
            paid: "Pagado 100%",
            unpaid: "No pagado",
            firstDay: "Del",
            lastDay: "Al",
            selectFinancialGroup: "Seleccionar grupo",
            warningInvoiceExists: "Ya existe una factura",
            newBio: "Nueva analítica",
            finalizeTo: "Finalizar en",
            imaging: {
                general: "Imagen",
                rxShort: "Rx",
                rxFull: "Radiografía",
                usShort: "Eco",
                usFull: "Ecografía",
                ct: "TAC",
                mrt: "RM",
                petScan: "PET-TAC",
                other: "Otro",
            },            
            healthPro: {
                medicalSpecialty: "Interconsulta",
                nurse: "Enfermero/a",
                physio: "Fisioterapeuta",
                ergo: "Terapeuta ocupacional",
                speech: "Logopeda",
                podiatrist: "Podólogo/a",
                pedicurist: "Pedicuro/a",
                dietitian: "Dietista",
                psychotherapist: "Psicoterapeuta",
                psychologist: "Psicólogo/a",
                psychomotor: "Psicomotricista",
                midwife: "Matrona"
            },
            luBill: {
                additionalInfo: "Información adicional",
            },
            luBilledAct: {
                date: "Fecha",
                mainLocation: "Lugar",
                subLocation: "Establecimiento",
                applyHospiClassToNextActs: "Aplicar clase {actClass} desde este día",
            },
            luBillAddon: {
                separateDates: "Separar fechas",
                codeOrAct: "Código o acto ...",
                acts: "Actos",
                generalActs: "Actos generales",
                technicalActs: "Actos técnicos",
                labActs: "Actos de laboratorio",
                withSupplement: "+ supl.",
                personalActs: "Actos personales",
                hospitalisation: "Hospitalización",
                prefix: "Prefijo",
                removePrefix: "Sin prefijo",
                suffix: "Sufijo",
                executor: "Ejecutante",
                surgeryAssistance: "Asistencia quirúrgica",
                customAct: {
                    description: "Descripción",
                    addCustomAct: "Agregar acto personal",
                },
                favoriteAct: {
                    description: "Descripción",
                },
            },
            variableResolver: {
                patient: {
                    title: "Paciente",
                    variable: {
                        patientfirstname:   "Nombre",
                        patientlastname:    "Apellido",
                        patientfullname:    "Nombre completo",
                        patientbirthdate:   "Fecha de nacimiento",
                        patientage:         "Edad",
                        patientphone:       "Teléfono",
                        patientstreet:      "Calle",
                        patientcity:        "Ciudad",
                        patientfulladdress: "Dirección completa",
                        patientemail:       "Correo electrónico",
                    }
                },
                healthpro: {
                    title: "Profesional de salud",
                    variable: {
                        profirstname:       "Nombre",
                        prolastname:        "Apellido",
                        profullname:        "Nombre completo",
                    }
                },
                entry: {
                    title: "Consulta",
                    variable: {
                        currentdate:        "Fecha",
                        currenttime:        "Hora",
                        currentlocation:    "Ubicación"
                    }
                }
            },
            suggestions: {
                addVariable: "Agregar una variable",
                autoUseFirst: "Rellenado automático",
                autoSelection: "Selección automática",
                withConsultationDate: "con la fecha de la consulta",
                withThisSelection: "con esta selección",
                withFirstSuggestion: "con la 1ª sugerencia",
                required: "requerido:",
                minimum: "mínimo",
                examplesTitle: "Ejemplos",
                examples: {
                    lines: {
                        title: "Por línea",
                        subtitle: "1 línea = 1 sugerencia",
                        example: "1x al mes\n1x a la semana\n1x cada 2 días"
                    },
                    blocks: {
                        title: "Por bloque",
                        subtitle: "Varias líneas = 1 sugerencia",
                        example: "Remito a este paciente para evaluación e informe.\nPresenta: \n ---\nRemito a este paciente con carácter urgente para evaluación e informe.\nPresenta:"
                    },
                    titledBlocks: {
                        title: "Por bloque con título",
                        subtitle: "Varias líneas = 1 sugerencia",
                        example: "--- Por defecto\nRemito a este paciente para evaluación e informe.\nPresenta: \n\n --- Urgente\nRemito a este paciente con carácter urgente para evaluación e informe.\nPresenta:"
                    }
                }
            }
        },
        admin: {
            title: "Paciente",
            relationship: {
                title: "Entorno",
                privatePatient: "Privado (pacientes)",
                privateCustom: "Privado (otros)",
                healthPro: "Profesionales de la salud",
            },
            invoiceHistory: "Facturas",
            appointments: "Citas",            
            note: "Notas {note}",
            noteTitle: "Notas:",
            phone: "Teléfono fijo",
            mobile: "Teléfono móvil",
            birthday: "Fecha de nacimiento",
            gender: "Género",
            langs: "Idioma(s)",
            email: "Correo electrónico",
            invalidEmail: "Correo electrónico inválido",
            address: "Dirección",
            maps: "Ver",
            ssl: "Seguridad Social Luxemburguesa",
            cnsNumber: {
                add: "Agregar matrícula",
                title: "Caja Nacional de Salud",
                copied: "Copiado"
            },
            cnsUpdate: {
                message: "CNS modificado exitosamente",
            },
            cmcm: {
                title: "CMCM",
            },
            cmcmModify: {
                title: "Caja médico-complementaria mutualista",
                useCmcm: "Inscrito CMCM",
            },
            referringDoctor: {
                title: "Médico de referencia",
                main: {
                    full: "Médico de referencia principal",
                    short: "MR principal",
                },
                second: {
                    full: "Médico de referencia sustituto",
                    short: "MR sustituto",
                },
                initialDeclarationDate: "Declaración inicial",
                declarationNumber: "N° declaración",
                createMrDeclaration: "Crear declaración",
                createMrRpa: "Crear RPA",
            },
            doc: {
                resume: "Resumen",
                prevention: "Ficha de prevención",
                bill: "Factura de honorarios"
            },
            subtitle: {
                contactDetail: "Datos de contacto",
                identityDetail: "Identidad",
                notificationDetail: "Preferencias de notificación"
            },
            subsubtitle: {
                contact: "Contactos",
                address: "Direcciones",
                healthPro: "Profesionales de salud",
                cns: "CNS",
                cmcm: "CMCM",
                workAccident: "Accidentes de trabajo",
                referringDoctor: "Médico de referencia",
            },
            notification: {
                deliveryType: {
                    DELIVERY_EMAIL: 'Correo electrónico',
                    DELIVERY_SMS: 'Sms',
                    DELIVERY_IN_APP: 'InApp'
                },
                preferredLanguage: "Preferencia de idioma para las comunicaciones",
                error: {
                    missingContactDetails: "Una o varias opciones están desactivadas porque no se ha especificado la información necesaria para enviar notificaciones."
                },
                noDefaultEmail: "Selecciona una dirección de correo electrónico predeterminada para cambiar las preferencias de notificaciones por correo electrónico."
            }
        },
        cns: {
            addCard: {
                title: "Matrícula",
            },
            modifyCard: {
                title: "Matrícula",
                useCnsNumber: "Usar matrícula",
            },
            editAffiliationNumberCard: {
                title: "Modificar matrícula",
                newCnsNumber: "Nuevo",
            },
        },
        entourageCard: {
            person: "Persona",
            name: "Apellido",
            birthName: "Apellido de nacimiento",
            firstName: "Nombre",
            link: "Vínculo",
            birthDate: "Fecha de nacimiento",
            gender: "Género administrativo",
            biologicalSex: "Sexo biológico",
            languages: "Idioma(s)",
            note: "Nota",
            phone: "Número",
            email: "Correo electrónico",
            street: "Calle",
            postalCode: "Código",
            locality: "Ciudad",
            country: "País",
            updateSuccess: "Información modificada exitosamente",
        },
        actionButton: {
            accessPatient: "Expediente",
            newEntry: "Nueva entrada",
            accessCalendar: "Cita",
            createTask: "Tarea",
            scrollToTop: "Volver arriba",
        },
        filters: {
            bio: "Bio",
            imaging: "Imagenología",
            reports: "Informes",
            other: "Otros",
            requests: "Recetas",
            users: "Usuario(s)",
            myConsultations: "Mis consultas",
        },
        pharmacy: {
            suggestions: {
                stop: "Stop",
                favorites: "Favoritos",
                lastPrescription: "Última prescripción",
                moreSubstances: "+ Sustancias",
                lessSubstances: "Menos sustancias",
                sameFamily: "Misma familia",
                similarComposition: "Composición similar"
            },
            prescriptionInfo: {
                patientInfos: "Información del paciente",
                pharmacyInfos: "Información de la farmacia",
                autoUseFirst: "Autocompletar",
            },
            posology: {
                then: "luego",
                asNeeded: "Si es necesario",
                during: "durante",
                stopIn: "parar en",
                days: "día(s)",
                infos: "infos",
                sequence: "secuencia",
                preference: {
                    addCurrentDose: "Añadir dosis actual",
                    emptyToUseSubstance: "Dejar vacío para usar las posologías siguientes",
                    addPosologies: "Añadir posologías",
                    posologies: "Posologías",
                    posologiesPlaceholder: "1 comprimido mañana y noche durante 7 días"
                }
            },
            title: "Duración máxima de prescripción",
            customDurationDays: "días",
            DefaultDuration: "Predeterminado de la receta",
            CustomDuration: "Personalizado",
            NotForPharmacy: "Nunca en receta",
            label: {
                DefaultDuration: "Receta: duración máx.",
                CustomDuration: "Receta: {days} días",
                NotForPharmacy: "Sin receta"
            },
        },        
        entry: {
            time: "Hora de la entrada",
            date: "Fecha de la entrada",
            archive: {
                header: "Eliminar esta entrada",
                message: "Estás a punto de eliminar una entrada",
                confirm: "La eliminación de la entrada se ha realizado correctamente"
            },
            archived: "Eliminada",
            archivedBy: "Eliminada por {author} el {deletedDate}",
            restore: {
                header: "Restaurar esta entrada",
                message: "Estás a punto de recuperar una entrada eliminada",
                confirm: "La restauración de la entrada se ha realizado con éxito"
            }
        },
        appointments: {
            empty: "Aucun rendez-vous",
            past: "Citas pasadas",
            coming: "Próximas citas",
            patientFullName: "Paciente",
            healthProFullName: 'Profesional de salud',
            type: "Tipo de cita",
            date: "Fecha de cita",
            time: "Hora de cita",
            appointmentInfo: "Comentarios sobre la cita",
            duration: "Duración de cita",
            appointmentDetails: "Detalles de cita",
            minutes: "minutos",
            withoutAppointment: "Sin cita previa"
        }
    },
    task: {
        taskTerm: 'Tarea',
        mainTitle: 'Tareas',
        myMissionsTitle: 'Mis tareas',
        assignedMissionsTitle: 'Tareas delegadas',
        twoPersonTitle: 'Chat',
        emptyState: 'Sin tareas',
        taskBoxCustomMenu: {
            addTaskBox: "Agregar canal",
        },
        twoPersonMenu: {
            addTaskBox: "Agregar chat",
        },
        importFiles: {
            integrateRenamed: 'Integrar archivos renombrados',
        },
        dropzone: {
            title: 'Agregar archivos',
            subtitle: 'Haga clic o arrastre aquí',
        },
        noteGroup: {
            missions: "Tareas",
            notes: "Notas",
            future: "Próximas",
            validated: "Validadas"
        },
        taskPriority: {
            DuringShift: "1 - Rápidamente",
            EndOfShift: "2 - Durante el día",
            NextDays: "3 - Próximos días",
            None: "4 - Menos urgente"
        },
        notePriority: {
            DuringShift: "1 - Muy importante",
            EndOfShift: "2 - Importante",
            NextDays: "3 - Normal",
            None: "4 - Poco importante"
        },
        since: "a partir del ...",
        private: "Nota privada",
        group: {
            message: {
                success: {
                    add: "Grupo de tareas creado exitosamente",
                    deactivate: "Grupo desactivado exitosamente",
                }
            }
        },
        import: {
            regibox: {
                message: {
                    startImport: {
                        summary: "Inicio de importación Regibox",
                        detail: "Archivo(s): {fileNumber}",
                    },
                    endImport: {
                        summary: "Importación Regibox",
                        detail: "Importaciones completas: {successful}\nImportaciones parciales: {tasksCreated}\nFallos: {failed}\n\n{errors}",
                    },
                    missingXmlData: "Archivos sin .xml en esta carpeta\nPor favor elimínelos primero",
                }
            }
        },
        status: {
            Pending: "Pendientes",
            Settled: "Validados",
            Rename: "Por renombrar"
        },
        taskBoxDetail: {
            deactivate: "Desactivar este canal"
        },
        taskBox: {
            creator: "Creador",
        }
    },
    accounting: {
        noData: "No se encontraron facturas",
        remainingBalance: "Saldo restante",
        truncated: "Resultados limitados",
        settled: "Pagado",
        transaction: "Transacción",
        newTransaction: "Nueva transacción",
        paymentType: "Tipo de pago",        
        search: {
            hasMore: "Resultados limitados, refine su búsqueda",
            minCharacters: "Mín. 4 caracteres ...",
        },
        editTransaction: {
            locked: "Esta transacción ya no se puede modificar",
        },
        econnector: {
            service: {
                noPort: "eConnector: error de puerto",
                error: "eConnector: error",
                technicalError: "Error técnico con eConnector",
                unspecifiedError: "Error no especificado",
            },
            pid: {
                title: "PID",
                unavailable: "PID no disponible",
                simulationRefused: "Simulación rechazada",
                contest: "Impugnar",
                cnsPart: "Parte CNS",
                patientPart: "Parte paciente",
                contestedOn: "Impugnado el",
                redoSimulation: "Rehacer simulación PID",
                confirm: "Confirmar"
            },
            ra: {
                title: "Reembolso acelerado",
                paidForCns: "PAGADO para CNS",
                notPaidForCns: "NO PAGADO para CNS",
                directTransmissionImpossible: "Transmisión directa CNS imposible",
                confirm: "Confirmar",
                withoutEConnector: "Sin eConnector"
            },
            sendMh: {
                toast: {
                    error: "Ha ocurrido un error al enviar la factura de honorarios a la CNS",
                    errorWithDetails: "Error(es): {details}",
                    success: "Factura de honorarios transmitida exitosamente a la CNS"
                }
            },
            cancelMh: {
                toast: {
                    error: "Ha ocurrido un error al cancelar la factura de honorarios en la CNS",
                    errorWithDetails: "Error(es): {details}",
                    success: "Factura de honorarios cancelada exitosamente en la CNS"
                },
                alreadyCancelled: "Esta factura ya ha sido cancelada",
                title: "Cancelación",
                titleEconnector: "Cancelación eConnector",
                transmittedViaEconnector: "Esta factura fue transmitida vía eConnector",
                cancellationImpossibleWithoutEconnector: "Cancelación imposible sin eConnector",
                econnectorDisabled: "eConnector deshabilitado",
                econnectorUnavailable: "eConnector no disponible",
                cancelAmount: "Cancelar monto",
                cancellationReason: "Motivo de cancelación",
                required: "Requerido",
                invoiceNumber: "Factura N°",
                invoiceDate: "Del",
                total: "Total"
            },
            pidSimulation: {
                toast: {
                    expiredSummary: "La simulación del PID ha expirado",
                    expiredDetail: "Por favor inicie una nueva simulación",
                    error: "Ha ocurrido un error durante la simulación del PID",
                    errorWithDetails: "Error(es): {details}",
                    refused: "PID rechazado",
                    stillValid: "Simulación PID aún válida",
                }
            },
            pidValidation: {
                toast: {
                    error: "Ha ocurrido un error durante la validación del PID",
                    success: "PID validado exitosamente",
                    errorWithDetails: "Error(es): {details}",
                }
            },
            pidContestation: {
                selectAnomaly: "Por favor seleccione la anomalía a impugnar",
                selectType: "Por favor seleccione el tipo de impugnación",
                type: {
                    interpretation: "Impugnación de la interpretación de una regla de tarificación hecha por el motor de reglas",
                    programatic: "Impugnación de un error de programación del motor de reglas"
                },
                toast: {
                    error: "Ha ocurrido un error durante la impugnación del PID",
                    success: "PID impugnado exitosamente",
                    errorWithDetails: "Error(es): {details}"
                }
            }
        },
        allMenu: {
            title: "Todos",
            precomplete: "Por finalizar"
        },
        financialSummary: {
            cancelled: "Cancelado",
            awaitingPayment: "En espera de pago",
            revenues: "Ingresos",
            directPayment: "Transferencia directa",
            includeImmediatePayments: "Incluir PID y tarjeta en ingresos",
        },
        financialGroupMenu: {
            disabled: "{groupName} (desactivado)",
            fixChannels: {
                remainingBalance: "Saldo restante",
            },
            fixGroups: {
                tpCreatedOn: "Grupo del {date}",
                notSubmitted: "Por hacer",
            },
            groupActions: {
                downloadBills: "Descargar facturas",
                downloadActs: "Descargar actos",
                downloadTransactions: "Descargar transacciones",
                exportForBob50: "Exportar para BOB 50",                
                openPidDashboard: "Historial de transmisiones",
            },
            channelTransactions: {
                cancelled: "cancelar",
                bankAccount: "por transferencia",
                cash: "en efectivo",
                bankCard: "con tarjeta",
                digitalPayment: "digital",
                luTp: "por TP",
                luTpSocial: "por TP social",
                luPid: "por PID",
                remainingBalance: "no pagado",
            },
            channelActions: {
                createPaymentReminders: "Crear recordatorios",
                createLuTpSheet: "Crear ficha TP",
                createLuTpSocialSheet: "Crear grupo TP social",
            },
            searchInvoice: "Factura",
            luTpSheet: "Extracto CNS",
        },
        filterMenu: {
            patient: "Paciente",
            date: "Fecha",
            healthPro: "Médico",
        },
        infos: {
            title: "Factura(s)",
        },
        stats: {
            menu: {
                title: "Historial",
            },
            body: {
                title: "Historial de: {groupName}",
                nbMHSent: "Honorarios enviados",
                nbPidValidated: "PIDs validados",
                nbPidContested: "PIDs impugnados",
                period: "Del {start} al {end}"
            }
        },
        invoice: {
            notCns: "Fuera de CNS",
            reminder: "Recordatorio nivel {sequence}",
            invoices: "Factura(s):",
        },
        invoiceReminder: {
            letter: "Carta",
            fee: "Gastos",
            invoices: "Facturas: ",
            selectionAlone: "Facturas",
            selectionWithReminders: "Facturas con carta",
            remindersWithSettled: "Recordatorios con otras facturas saldadas",
            remindersNotPrinted: "{count} recordatorio(s) no impreso(s) — saldado(s) desde",
            reminders: "Recordatorios",
            reminder: "Recordatorio N° {sequence}",
            reminderSettings: {
                title: "Configuración",
                saved: "Configuración de recordatorios",
            },
        },
    },
    login: {
        title: "Conexión",
        subtitle: "Por favor elija un método de conexión para continuar",
        smartCard: "Conectarse con LuxTrust SmartCard",
        mobile: "Conectarse con LuxTrust Mobile",
        noAccount: "¿No tiene cuenta?",
        askToBeContacted: "Solicitar ser contactado",
        needHelp: "¿Necesita ayuda?",
        contactUs: "Contáctenos",
        welcome: "Bienvenido a eSklepios",
        welcomeSubtitle: "Menos administración, más cuidado",
        catchphrase: "La tecnología al servicio de la salud",
        description: "Benefíciese de herramientas poderosas para una mejor atención al paciente",
    },
    refSheet: {
        title: "Ficha",
        list: "Fichas",
        names: "Nombres",
        searchRefSheet: "Buscar ficha",
        selectRefSheet: "Seleccionar una ficha",
        assessment: {
            signs: "Signos",
            prescriptionsFirst: "Prescripciones - 1.ª línea",
            prescriptionsSecond: "Prescripciones - 2.ª línea",
        },
        tabs: {
            Sheet: "Ficha",
            Presentation: "Cuadro clínico",
            Etio: "Etio",
            Complic: "Complic",
            Treatment: "Tratamiento",
            Invoice: "Facturación",
        },
        treatment: {
            medication: "Medicamentos",
            healthPro: "Profesionales sanitarios",
            administratif: "Administrativo",
        },
        invoice: {
            billingCodes: "Códigos de facturación",
        },
        referenceDocument: {
            title: "Plantilla",
            list: "Plantillas",
            create: "Crear plantilla",
            newTitle: "Título de la plantilla",
            newTitleExample: "p. ej. Rehabilitación inicial o Informe estándar",
        },
        referenceLink: {
            title: "Enlace de referencia",
            list: "Enlaces de referencia",
        },
        referenceFile: {
            title: "Archivo de referencia",
            list: "Archivos de referencia",
        },
        patientFile: {
            title: "Documento para el paciente",
            list: "Documentos para el paciente",
        },
    },
    posos: {
        error: {
            loading: "Error al cargar el widget POSOS"
        },
        unresolved: {
            drugs: "Medicamentos no analizados",
            strengthMismatches: "Aproximaciones",
            conditions: "Antecedentes no analizados",
            allergies: "Alergias no analizadas"
        }
    }    
} satisfies MessageSchema;